(() => {
  'use strict';

  function refreshCartDrawer() {
    return fetch('/?sections=cart-drawer-section')
      .then((r) => r.json())
      .then((sections) => {
        const html = sections['cart-drawer-section'];
        if (!html) return;
        const wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        const fresh = wrapper.querySelector('#shopify-section-cart-drawer-section');
        const current = document.getElementById('shopify-section-cart-drawer-section');
        if (fresh && current) current.replaceWith(fresh);
      });
  }

  function openCartDrawer() {
    const drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  // The header count is server-rendered, so after an AJAX add it kept saying Cart (0) until
  // the next full page load — the one place the shopper looks to confirm the tap worked.
  function refreshCartCount() {
    const link = document.querySelector('.meningea-header__cart');
    if (!link) return Promise.resolve();
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => { link.textContent = `Cart (${cart.item_count})`; })
      .catch(() => {});
  }

  function handleSubmit(form, event) {
    event.preventDefault();
    // The sticky mobile buy bar's button lives outside the form and is attached to it via
    // form=, so the submitter is the only reliable way to put "Adding…" on the control the
    // shopper actually pressed rather than on the one further up the page.
    const button = event.submitter || form.querySelector('[type="submit"]');
    const prevText = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }

    const formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then((r) => {
        if (!r.ok) return r.json().then((err) => Promise.reject(err));
        return r.json();
      })
      .then(() => Promise.all([refreshCartDrawer(), refreshCartCount()]))
      .then(() => openCartDrawer())
      .catch((err) => {
        console.warn('[meningea-cart-ajax] add to cart failed', err);
        form.submit();
      })
      .finally(() => {
        if (button) { button.disabled = false; button.textContent = prevText; }
      });
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-meningea-cart-form]');
    if (!form) return;
    handleSubmit(form, event);
  });
})();
